module.exports = __webpack_public_path__ + "static/media/position_closed.43f48582.svg";